import { useEffect } from 'react';
import InvoicesInboxEmailDrawer from './InvoicesInboxEmailDrawer';
import InvoicesInboxList from './InvoicesInboxList';
import useDrawerStack from 'Hooks/useDrawerStack';

export default function InvoicesInboxDrawer() {
    const { open, register } = useDrawerStack();

    useEffect(() => {
        register([['invoices-inbox-email', InvoicesInboxEmailDrawer]]);
    }, []);

    const handleViewEmail = (email) => {
        open('invoices-inbox-email', {
            title: email.subject,
            email,
        });
    };

    return <InvoicesInboxList onViewEmail={handleViewEmail} />;
}
